// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireOption-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireOption.mobile.scss
 ** module id = 897
 ** module chunks = 1
 **/